import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { pascalCase } from "./lib/pascalCase.js";
const TODOSliceComponent = ({ slice }) => {
  if (process.env.NODE_ENV === "development") {
    const type = "slice_type" in slice ? slice.slice_type : slice.type;
    console.warn(`[SliceZone] Could not find a component for Slice type "${type}"`, slice);
    return /* @__PURE__ */ jsxs("section", { "data-slice-zone-todo-component": "", "data-slice-type": type, children: [
      "Could not find a component for Slice type “",
      type,
      "”"
    ] });
  } else {
    return null;
  }
};
const SliceZone = ({ slices = [], components = {}, resolver, defaultComponent = TODOSliceComponent, context = {} }) => {
  const renderedSlices = React.useMemo(() => {
    return slices.map((slice, index) => {
      const type = "slice_type" in slice ? slice.slice_type : slice.type;
      let Comp = components[type] || defaultComponent;
      if (resolver) {
        const resolvedComp = resolver({
          slice,
          sliceName: pascalCase(type),
          i: index
        });
        if (resolvedComp) {
          Comp = resolvedComp;
        }
      }
      const key = "id" in slice && slice.id ? slice.id : `${index}-${JSON.stringify(slice)}`;
      return /* @__PURE__ */ jsx(Comp, { slice, index, slices, context }, key);
    });
  }, [components, context, defaultComponent, slices, resolver]);
  return /* @__PURE__ */ jsx(Fragment, { children: renderedSlices });
};
export {
  SliceZone,
  TODOSliceComponent
};
//# sourceMappingURL=SliceZone.js.map
